export default {
    fileSearch: {
        page: {
            FileName: '文件名',
            FileFormat: '文件格式',
            UploadedBy: '上传人',
            SourceType: '来源类型',
            FileUpload: '文件上传',
            Preview: '预览',
            Download: '下载',
        },
        table: {
            Tenant: '租户',
            Grouping: '分组',
            UploadDirectory: '上传目录',
            AssociationTable: '关联表',
            FileType: '文件类型',
            FileName: '文件名',
            UploadedBy: '上传人',
            CreationTime: '创建时间',
            UpdateTime: '更新时间',
            FileSize: '文件大小',
            BatchNo: '批号',
            SourceType: '来源类型',
            Operation: '操作',
        },
        dialog: {
            Configuration: '配置',
            FileClassification: '文件分类',
            code: '存储配置编码',
            file: '文件'
        },
        common: {
            Grouping: '分组',
            UploadDirectory: '上传目录',
        }
    },
};
